import { useState } from 'react';
import { Button } from './components';
import { Icon } from './icons';

export function CopyButton({ text, label = 'Nusxalash' }: { text: string; label?: string }) {
  const [done, setDone] = useState(false);
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(text);
      setDone(true);
      setTimeout(() => setDone(false), 1500);
    } catch {
      /* brauzer ruxsat bermadi — foydalanuvchi qo'lda belgilab oladi */
    }
  };
  return (
    <Button size="sm" variant="secondary" onClick={() => void copy()}>
      <Icon name={done ? 'check' : 'copy'} /> {done ? 'Nusxalandi' : label}
    </Button>
  );
}

// Bir marta ko'rsatiladigan maxfiy qiymat (parol, PIN, ulash kodi) — katta, o'qilishi oson.

export function Secret({ label, value, hint }: { label: string; value: string; hint?: string }) {
  return (
    <div className="cn-secret">
      <span className="cn-secret__label">{label}</span>
      <span className="cn-secret__value op-mono">{value}</span>
      <span className="cn-secret__actions">
        <CopyButton text={value} />
      </span>
      {hint && <span className="cn-secret__hint">{hint}</span>}
    </div>
  );
}
